"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _icons = require("@material-ui/icons");
var _core = require("@material-ui/core");
var _style = _interopRequireDefault(require("./style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DialogTitle = _ref => {
  let {
    onClose,
    children,
    className,
    disableTypography = true,
    ...props
  } = _ref;
  const classes = (0, _style.default)(props);
  return /*#__PURE__*/_react.default.createElement(_core.DialogTitle, _extends({
    disableTypography: disableTypography,
    className: (0, _clsx.default)(className, classes.root)
  }, props), children && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    component: "h4"
  }, children), onClose && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onClose,
    className: classes.closeButton
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    htmlColor: "#0D0D0D",
    fontSize: "small"
  })));
};
var _default = exports.default = DialogTitle;